"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHoverColor = void 0;
var _tinycolor = require("@ctrl/tinycolor");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

/**
 * Get hover color that is either darker or lighter version of the color based on the color 'brightness'.
 * @param {string} myColor - base color
 * @param {number} brightnessThreshold - color brightness threshold (0-255) for choosing wether to darken or lighten the color
 * @param {number} degreeOfAdjustment - degree to which adjust the color (0-100) - making it darker or lighter
 */

var getHoverColor = exports.getHoverColor = function getHoverColor(myColor) {
  var brightnessThreshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 155;
  var degreeOfAdjustment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
  var color = typeof myColor === "string" ? new _tinycolor.TinyColor(myColor) : myColor;
  return color.getBrightness() < brightnessThreshold ? color.darken(degreeOfAdjustment) : color.lighten(degreeOfAdjustment);
};